import React, { useEffect, useRef } from "react";

const KEY_PREFIX = "mew_ta_height:";

interface PersistentTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  storageKey?: string;
}

export default function PersistentTextarea({ storageKey, style, ...props }: PersistentTextareaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !storageKey) return;
    const key = KEY_PREFIX + storageKey;

    const saved = localStorage.getItem(key);
    if (saved) el.style.height = saved;

    const observer = new ResizeObserver(() => {
      if (el.style.height) localStorage.setItem(key, el.style.height);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [storageKey]);

  return <textarea ref={ref} style={style} {...props} />;
}
